export { default } from './GameController'
